module.exports = __webpack_public_path__ + "static/social-facebook-1e8f8f40c10231ce8ad200a04dd874cc.svg";